module.exports = __webpack_public_path__ + "static/media/grey.f401435d.svg";